import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";

const IntentProjectsTableLabelsCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={intentProject.labels} />
    </TableSimpleCell>
  );
};

export default IntentProjectsTableLabelsCell;
